<template>
	<nav class="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
		<div class="navbar-menu-wrapper d-flex align-items-center"
			style="background-color: #0D283F;width: 100% !important;border-bottom: 1px solid #007297;">
			<ul class="navbar-nav navbar-nav-left">
				<li>
					<img src="../../assets/images/logo3.png" style="height: 40px;margin: 0px 10px;" alt="">
				</li>
				<li><span style="font-size: 18px;margin-left: 20px;">充检桩管理系统</span></li>
			</ul>
			<ul class="navbar-nav navbar-nav-right">
				<li class="nav-item dropdown d-none d-xl-inline-block">
					<a class="nav-link dropdown-toggle" id="UserDropdown" href="#" data-toggle="dropdown"
						aria-expanded="false">
						<i class="mdi mdi-account"></i>
						<span class="profile-text">{{userName}}</span>
					</a>
					<div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="UserDropdown">
						<a class="dropdown-item">
							账号管理
						</a>
						<a class="dropdown-item" @click="dialogVisible=true">
							修改密码
						</a>
						<a class="dropdown-item" @click="onExit()">
							退出
						</a>
					</div>
				</li>
			</ul>
			<button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
				data-toggle="offcanvas">
				<span class="mdi mdi-menu"></span>
			</button>

		</div>

		<el-dialog title="修改密码" :visible="dialogVisible" width="400px" :modal-append-to-body="false"
			:before-close="handleClose">
			<el-form :inline="true" label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm"
				class="demo-form-inline dolform" size="small">
				<el-form-item label="原始密码" prop="original" label-width="120px">
					<el-input type="password" v-model="ruleForm.original" placeholder="请输入原始密码"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="newPassword" label-width="120px">
					<el-input v-model="ruleForm.newPassword" placeholder="请输入新密码" autocomplete="off">
					</el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPassword" label-width="120px" style="margin-bottom: 0px;">
					<el-input v-model="ruleForm.confirmPassword" placeholder="请输入确认密码" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" class="querybtn" size="small" @click="submitForm('ruleForm')">确 定
				</el-button>
				<el-button class="cancelbtn" @click="resetForm('ruleForm');" size="small" plain>取 消
				</el-button>
			</span>
		</el-dialog>
	</nav>
</template>
<script>
	export default {
		components: {},
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.confirmPassword !== '') {
						this.$refs.ruleForm.validateField('confirmPassword');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.newPassword) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				userName: '',
				dialogVisible: false,
				ruleForm: {
					original: '',
					newPassword: '',
					confirmPassword: '',
				},
				rules: {
					original: [{
						required: true,
						message: '原始密码不能为空',
						trigger: 'blur'
					}],
					newPassword: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					confirmPassword: [{
						validator: validatePass2,
						trigger: 'blur'
					}]
				},
			}
		},
		mounted() {
			let _this = this;
			_this.userName = sessionStorage.getItem('accounts');
			let username=this.$cookie.get("accounts");
			if(username!=null){
				_this.userName = username;
			}
		},
		methods: {
			handleClose(done) {
				this.dialogVisible = false;
			},
			onExit: function() {
				let _this = this;
				this.$api.post('/logOut', {},
					function(response, context) {
						_this.$message({
							showClose: true,
							message: response.message,
							type: response.code == "200" ? 'success' : 'error'
						});
						if (response.code == "200") {
							sessionStorage.clear();
							_this.$cookie.remove("accounts")
							_this.$cookie.remove("password")
							_this.$cookie.remove("Authorization")
							// _this.$router.push('/test');
							window.location.href='/';
						}
					}
				);
			},

			onUpdatePassword: function() {
				let _this = this;
				this.$api.post(_this.$utils.config.link54, {
						confirmPassword: _this.ruleForm.confirmPassword,
						newPassword: _this.ruleForm.newPassword,
						original: _this.ruleForm.original,
					},
					function(response, context) {
						_this.$message({
							showClose: true,
							message: response.message,
							type: response.code == "200" ? 'success' : 'error'
						});
						if (response.code == "200") {
							sessionStorage.clear();
							_this.$router.push('/login');
						}
					}
				);
			},


			//保存
			submitForm: function(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.onUpdatePassword();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm: function(formName) {
				this.ruleForm = {};
				this.dialogVisible = false;
			},
		},
	}
</script>

<style lang="scss">
	.navbar {
		.nav-item {
			margin: 0px 10px !important;

			.nav-link i {
				font-size: 20px !important;
				margin-right: 10px !important;
			}
		}

		.dropdown-menu {
			font-size: 14px !important;
			width: 110px !important;
			top: 65px !important;
			min-width: 110px !important;
			position: fixed !important;
			right: 30px !important;
			padding: 20px 0px !important;
		}

		.el-dialog {
			border: 1px solid #007297 !important;

			.el-form--inline .el-form-item__label {
				margin-bottom: 10px !important;
			}
		}
	}
</style>
